module.exports = __webpack_public_path__ + "img/09徐向南.6e2abfb9.jpg";